import React from 'react';
import CertBadgePicture from '../assets/badge.png';
import styles from './CertBadge.module.scss';

interface CertBadgeProps {
	/** Whether to show the shimmer animation effect */
	shimmer?: boolean;
	/** Custom CSS class for additional styling */
	className?: string;
	/** Alt text for the badge image */
	alt?: string;
	/** Custom positioning style overrides */
	style?: React.CSSProperties;
	width?: number;
	height?: number;
}

export const CertBadge: React.FC<CertBadgeProps> = ({
	shimmer = false,
	className = '',
	alt = 'badge',
	style = {},
	width = 50,
	height = 50
}) => {
	return (
		<div
			className={`${styles.badgeContainer} ${shimmer ? styles.shimmer : ''} ${className}`}
			style={{
				...style,
				width: width,
				height: height,
			}}
		>
			<img
				src={CertBadgePicture}
				alt={alt}
				className={styles.badgeImage}
				width={width}
				height={height}
			/>
			{shimmer && (
				<div className={styles.shimmerOverlay}></div>
			)}
		</div>
	);
};

export default CertBadge; 